import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { CustomizeService } from '../customize-service';
import { SkillApiService } from '../../apis/skill-api';
import { McpApiService } from '../../apis/mcp-api';
import type {
    WebSkillListParams,
    WebSkillCreateRequest,
    WebSkillUpdateRequest,
    WebSkillImportRequest,
    WebSkillSecurityCheckRequest,
    WebMcpListParams,
    WebMcpDetailParams,
} from '../../types';

@injectable()
export class CustomizeServiceImpl implements CustomizeService {
    constructor(
        @inject(SkillApiService) private skillApi: SkillApiService,
        @inject(McpApiService) private mcpApi: McpApiService
    ) {}

    getSkillList(params?: WebSkillListParams) {
        return this.skillApi.getList(params);
    }

    getSkillDetail(id: string) {
        return this.skillApi.getDetail(id);
    }

    createSkill(data: WebSkillCreateRequest) {
        return this.skillApi.create(data);
    }

    updateSkill(id: string, data: WebSkillUpdateRequest) {
        return this.skillApi.update(id, data);
    }

    enableSkill(id: string) {
        return this.skillApi.enable(id);
    }

    disableSkill(id: string) {
        return this.skillApi.disable(id);
    }

    deleteSkill(id: string) {
        return this.skillApi.remove(id);
    }

    exportSkill(id: string) {
        return this.skillApi.exportSkill(id);
    }

    importSkill(data: WebSkillImportRequest) {
        return this.skillApi.importSkill(data);
    }

    validateImportSecurity(data: WebSkillSecurityCheckRequest) {
        return this.skillApi.validateImportSecurity(data);
    }

    getMcpList(params?: WebMcpListParams) {
        return this.mcpApi.getList(params);
    }

    getMcpDetail(id: string, params?: WebMcpDetailParams) {
        return this.mcpApi.getDetail(id, params);
    }

    enableMcp(id: string) {
        return this.mcpApi.enable(id);
    }

    disableMcp(id: string) {
        return this.mcpApi.disable(id);
    }
}
